import React from "react";

export const TcpChange = ({ currentTcp, previousTcp }) => {
  return <span>{currentTcp > previousTcp ? "📈" : "📉"}</span>;
};
